
function NaoEncontrada() {
    return (
        <section style={{height: '66vh'}}>
            <h2>Ops!</h2>
            <p>O conteúdo que você procura não foi encontrado!</p>
        </section>
    )
}

export default NaoEncontrada;
